import React from 'react';
import {
  ProjectDetailsField,
  UpdateGlobalDetailsFieldRequest,
  useProjectDetailsFieldsAdminService
} from 'nekst-api';
import { AfterSubmitFunc, FormTemplate, TextInput, useShowContextRequired } from 'ui-builder';
import ProjectDetailsFieldTypeDropdown
  from '../../../projectdetails/CreateUpdate/ProjectDetailsFieldTypeDropdown';
import { OpenFormIconButton } from 'features/nekst-widgets';
import { ProjectTypeMultiSelectDropdown } from 'features/tasks-forms';
import ParentFieldDropdown from '../../../projectdetails/Sets/List/ParentFieldDropdown';

export function EditDetailBoxForm(props: {
  field: ProjectDetailsField,
  afterSubmitFunc?: AfterSubmitFunc
}) {
  const service = useProjectDetailsFieldsAdminService();

  return (
    <FormTemplate<UpdateGlobalDetailsFieldRequest>
      title="Update Detail Box"
      submitFormFunc={async (data) => {
        await service.updateField(
          props.field.id,
          data
        );

        return data;
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          }
        },
        fieldType: {
          type: 'string',
          constraints: {
            required: true,
          }
        },
        projectTypes: {
          type: 'array',
          constraints: {
            required: true,
          }
        }
      }}
      initialData={props.field}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput
        source="name"
        label="Name"
      />
      <ProjectDetailsFieldTypeDropdown source="fieldType" label="Box Type" />
      <ProjectTypeMultiSelectDropdown source="projectTypes" label="Transaction Types" />
      <ParentFieldDropdown isDisabled />
    </FormTemplate>
  );
}

export function EditDetailBoxFormButton() {
  const showContext = useShowContextRequired<ProjectDetailsField>();
  return (
    <OpenFormIconButton
      form={<EditDetailBoxForm field={showContext.data} />}
    />
  );
}
